import request from '@/utils/http';

// 条码规则分页查询
export const getBarCodeRule = (params) => {
    return request({
        url: '/api-sn/cdBarcodeRule/searchPage',
        method: 'post',
        data: params
    }).then(res => res);
};
// 条码规则保存
export const saveBarCodeRule = (params) => {
    return request({
        url: '/api-sn/cdBarcodeRule/save',
        method: 'post',
        data: params
    }).then(res => res);
};
// 条码规则明细保存
export const saveBarCodeRuleDetail = (params) => {
    return request({
        url: '/api-sn/cdBarcodeParaDefine/save',
        method: 'post',
        data: params
    }).then(res => res);
};

// 条码规则明细查询
export const getBarCodeRuleDetail = (params) => {
    return request({
        url: '/api-sn/cdBarcodeParaDefine/searchPage',
        method: 'post',
        data: params
    }).then(res => res);
};

// 条码规则明细删除
export const deleteBarCodeRuleDetail = (params) => {
    return request({
        url: '/api-sn/cdBarcodeParaDefine/delete',
        method: 'post',
        data: params
    }).then(res => res);
};

// 条码规则组分页查询
export const getBarCodeRuleGroup = (params) => {
    return request({
        url: '/api-sn/cdBarcodeRuleGroups/searchPage',
        method: 'post',
        data: params
    }).then(res => res);
};

// 条码规则组保存
export const saveBarCodeRuleGroup = (params) => {
    return request({
        url: '/api-sn/cdBarcodeRuleGroups/save',
        method: 'post',
        data: params
    }).then(res => res);
};
// 条码规则组明细保存
export const saveBarCodeRuleDetailGroup = (params) => {
    return request({
        url: '/api-sn/cdBarcodeRuleGroupDtl/save',
        method: 'post',
        data: params
    }).then(res => res);
};

// 条码规则组明细查询
export const getBarCodeRuleDetailGroup = (params) => {
    return request({
        url: '/api-sn/cdBarcodeRuleGroupDtl/searchPage',
        method: 'post',
        data: params
    }).then(res => res);
};

// 条码规则组明细删除
export const deleteBarCodeRuleDetailGroup = (params) => {
    return request({
        url: '/api-sn/cdBarcodeRuleGroupDtl/delete',
        method: 'post',
        data: params
    }).then(res => res);
};